/* =========================================================
   FITNES DREHI · SIDE CART
   Публично API (за landing страници, бутони и др.):
     SideCart.open() / SideCart.close()
     SideCart.add([{ id: variantId, quantity: 1 }])   -> Promise
     SideCart.refresh()                                -> Promise
     SideCart.state()  -> { count, eligible, tier, nextQty, nextPct, total }
   Събитие: document 'sidecart:updated' (detail = state)
   Обновяването е чрез Shopify Section Rendering API: HTML-ът идва от Liquid,
   затова цените, старите цени и отстъпките са винаги реалните.
   ========================================================= */
(function () {
  'use strict';
  var root = document.querySelector('[data-sc]');
  if (!root || window.SideCart) return;

  var SID = root.getAttribute('data-section-id');
  var BUBBLE = root.getAttribute('data-bubble-section') || '';
  var OPEN_ON_ADD = root.getAttribute('data-open-on-add') === 'true';
  var BASE = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var SECTIONS = [SID].concat(BUBBLE ? [BUBBLE] : []).join(',');
  // Непубликувана тема (Preview): всяка заявка трябва да носи preview_theme_id, иначе Shopify
  // рендерира секциите с публикуваната тема, където side-cart липсва, и количката не се обновява.
  var PREVIEW_ID = new URLSearchParams(location.search).get('preview_theme_id') ||
    (window.Shopify && window.Shopify.theme && window.Shopify.theme.role && window.Shopify.theme.role !== 'main' ? window.Shopify.theme.id : '') || '';
  function withPreview(u) {
    return PREVIEW_ID ? u + (u.indexOf('?') > -1 ? '&' : '?') + 'preview_theme_id=' + encodeURIComponent(PREVIEW_ID) : u;
  }
  var SECTIONS_URL = withPreview(location.pathname);
  var lastFocus = null;

  /* ---------- open / close ---------- */
  function open() {
    if (root.classList.contains('is-open')) return;
    lastFocus = document.activeElement;
    root.classList.add('is-open');
    document.documentElement.classList.add('sc-lock');
    var dr = root.querySelector('.sc-dr');
    if (dr) dr.focus({ preventScroll: true });
    document.dispatchEvent(new CustomEvent('sidecart:open'));
  }
  function close() {
    root.classList.remove('is-open');
    document.documentElement.classList.remove('sc-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    document.dispatchEvent(new CustomEvent('sidecart:close'));
  }

  /* ---------- state ---------- */
  function state() {
    var el = root.querySelector('[data-sc-state]');
    try { return JSON.parse(el.textContent); } catch (e) { return { count: 0 }; }
  }
  function emit() {
    document.dispatchEvent(new CustomEvent('sidecart:updated', { detail: state() }));
  }

  /* ---------- section rendering ---------- */
  function apply(sections) {
    if (!sections) return;
    var html = sections[SID];
    if (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var next = doc.querySelector('[data-sc-inner]');
      var cur = root.querySelector('[data-sc-inner]');
      if (next && cur) {
        var body = cur.querySelector('.sc-body');
        var top = body ? body.scrollTop : 0;
        cur.parentNode.replaceChild(next, cur);
        var nb = next.querySelector('.sc-body');
        if (nb) nb.scrollTop = top;
      }
    }
    if (BUBBLE && sections[BUBBLE]) {
      var target = document.getElementById(BUBBLE);
      if (target) {
        var d2 = new DOMParser().parseFromString(sections[BUBBLE], 'text/html');
        var src = d2.getElementById('shopify-section-' + BUBBLE) || d2.body;
        target.innerHTML = src.innerHTML;
      }
    }
    tick();
    emit();
  }

  // Предпазител: количката никога не остава "заета" повече от 12 секунди (увиснала заявка)
  var busyTimer = null;
  function busy(on) {
    root.classList.toggle('is-busy', !!on);
    clearTimeout(busyTimer);
    if (on) busyTimer = setTimeout(function () { root.classList.remove('is-busy'); }, 12000);
  }
  function withTimeout(p, ms) {
    return Promise.race([p, new Promise(function (_, rej) { setTimeout(function () { rej(new Error('timeout')); }, ms); })]);
  }

  function request(url, body) {
    var isForm = body instanceof FormData;
    // Без preview_theme_id в адреса: при POST с FormData Shopify тогава не чете тялото и връща
    // "Required parameter missing or invalid: items". Темата за рендерирането идва от sections_url.
    return fetch(BASE + url, {
      method: 'POST',
      headers: isForm ? { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest', 'X-Side-Cart': '1' }
                      : { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Side-Cart': '1' },
      body: isForm ? body : JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok || j.status) throw j;
        return j;
      });
    });
  }

  function add(items) {
    busy(true);
    return request('cart/add.js', { items: items, sections: SECTIONS, sections_url: SECTIONS_URL })
      .then(function (res) { refreshSeq++; apply(res.sections); if (OPEN_ON_ADD) open(); return res; })
      .catch(fail)
      .then(function (r) { busy(false); return r; });
  }

  function addForm(form, submitter) {
    var fd = new FormData(form);
    if (submitter && submitter.name) fd.append(submitter.name, submitter.value);
    fd.append('sections', SECTIONS);
    fd.append('sections_url', SECTIONS_URL);
    var btn = submitter || form.querySelector('[type="submit"]');
    if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.classList.add('loading'); }
    busy(true);
    return request('cart/add.js', fd)
      .then(function (res) { refreshSeq++; apply(res.sections); if (OPEN_ON_ADD) open(); return res; })
      .catch(fail)
      .then(function (r) {
        busy(false);
        if (btn) { btn.removeAttribute('aria-disabled'); btn.classList.remove('loading'); }
        return r;
      });
  }

  function change(key, qty, linked) {
    busy(true);
    return request('cart/change.js', { id: key, quantity: qty, sections: SECTIONS, sections_url: SECTIONS_URL })
      .then(function (res) {
        refreshSeq++; apply(res.sections);
        // Дреха с печат (fd-linked-cart.js): след промяната синхронизираме свързаните такси
        // (количеството им следва дрехата, а при премахване се махат). При проблем количката не блокира.
        if (linked && window.FDLinkedCart && typeof window.FDLinkedCart.sync === 'function') {
          withTimeout(window.FDLinkedCart.sync(), 15000)          // във фона: количката не чака
            .catch(function () {})
            .then(function () { return refresh(); });
        }
        return res;
      })
      .catch(fail)
      .then(function (r) { busy(false); return r; });
  }

  // Винаги свежо съдържание: без кеш на браузъра (иначе след добавяне от темата/приложение може да се
  // покаже старата празна количка) и само най-новият отговор се прилага (няколко обновявания едновременно).
  // Заявката е към корена на магазина и БЕЗ хедър Accept: application/json. На продуктова страница
  // Shopify тогава връща JSON данните на продукта вместо секциите и количката не се обновява.
  var refreshSeq = 0;
  function refresh() {
    var seq = ++refreshSeq;
    var url = withPreview(BASE + '?sections=' + encodeURIComponent(SECTIONS) + '&_sc=' + Date.now());
    return fetch(url, { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (sections) { if (seq === refreshSeq) apply(sections); })
      .catch(function () {});
  }

  function fail(err) {
    toast((err && (err.description || err.message)) || root.getAttribute('data-t-error') || 'Error');
    return null;
  }

  /* ---------- clicks inside the cart ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!root.contains(t)) return;
    if (t.closest('[data-sc-close]')) { e.preventDefault(); close(); return; }
    var q = t.closest('[data-sc-qty]');
    if (q) { e.preventDefault(); change(q.getAttribute('data-key'), +q.getAttribute('data-sc-qty'), q.hasAttribute('data-sc-linked')); return; }
    var x = t.closest('[data-sc-xs-add]');
    if (x) {
      e.preventDefault();
      var v = x.closest('.sc-x').querySelector('[data-sc-variant]');
      x.disabled = true;
      add([{ id: +v.value, quantity: 1 }]).then(function () { x.disabled = false; });
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && root.classList.contains('is-open')) close(); });

  /* ---------- open from anywhere: [data-sc-open] and the theme cart icon ---------- */
  var ICON = root.getAttribute('data-icon-selector');
  document.addEventListener('click', function (e) {
    var el = e.target.closest('[data-sc-open]' + (ICON ? ', ' + ICON : ''));
    if (!el || root.contains(el)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    open();
  }, true);

  /* ---------- take over "Add to cart" forms site-wide ---------- */
  var SKIP = '[data-sc-skip], cart-drawer, cart-notification, fd-linked-atomic, fd-linked-test';
  function isCartForm(f) {
    if (!(f instanceof HTMLFormElement)) return false;
    if (!/\/cart\/add/.test(f.getAttribute('action') || '')) return false;
    if (f.closest(SKIP)) return false;                       // количката на темата, персонализирани форми
    // Само стандартна форма с избран вариант. Ако няма id (напр. персонализация с няколко размера,
    // файлове и такси), формата се обработва от собствения си код, иначе Shopify връща
    // "Required parameter missing or invalid: items".
    var id = f.elements.namedItem('id');
    if (id && id.length && !id.value) id = id[0];
    return !!(id && id.value);
  }
  if (root.getAttribute('data-intercept-forms') === 'true') {
    // 1) Клик върху бутона "Добави". Хващаме го ПРЕДИ темата, защото някои теми (напр. Shrine)
    //    обработват клика сами и спират изпращането на формата, така че submit изобщо не настъпва.
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('button, input[type="submit"]');
      if (!btn || root.contains(btn)) return;
      if ((btn.getAttribute('type') || 'submit').toLowerCase() !== 'submit') return;
      if (btn.name === 'checkout') return;
      var f = btn.form;
      if (!isCartForm(f)) return;
      // Задължителни полета на темата (Shrine: data-required-fields / data-valid-fields) - оставяме темата да валидира
      var req = +btn.getAttribute('data-required-fields') || 0, val = +btn.getAttribute('data-valid-fields') || 0;
      if (req > val) return;
      if (!f.noValidate && f.checkValidity && !f.checkValidity()) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      if (btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
      addForm(f, btn);
    }, true);
    // 2) Изпращане на формата по друг начин (Enter, програмно)
    document.addEventListener('submit', function (e) {
      var f = e.target;
      if (!isCartForm(f)) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      addForm(f, e.submitter);
    }, true);
  }

  /* ---------- Замества количката на темата ----------
     Темата и скриптове като fd-linked-cart.js отварят <cart-drawer> на темата (drawer.open()
     или клас "active"). Тук всяко такова отваряне се пренасочва към тази количка. */
  function replaceThemeCart() {
    if (root.getAttribute('data-replace-theme-cart') !== 'true') return;
    document.documentElement.classList.add('sc-replace');
    var drawers = document.querySelectorAll('cart-drawer, cart-notification');
    for (var i = 0; i < drawers.length; i++) {
      var d = drawers[i];
      if (d.__scReplaced) continue;
      d.__scReplaced = true;
      d.open = function () { refresh().then(open); };
      if (window.MutationObserver) {
        new MutationObserver(function (list) {
          list.forEach(function (m) {
            var el = m.target;
            if (!el.classList.contains('active') && !el.classList.contains('animate')) return;
            el.classList.remove('active', 'animate');
            document.body.classList.remove('overflow-hidden', 'overflow-hidden-mobile', 'overflow-hidden-tablet');
            refresh().then(open);
          });
        }).observe(d, { attributes: true, attributeFilter: ['class'] });
      }
    }
  }
  replaceThemeCart();
  document.addEventListener('DOMContentLoaded', replaceThemeCart);

  /* ---------- Промени в количката, направени от темата или приложения ---------- */
  var syncTimer = null, openAfterSync = false;
  function scheduleSync(opened) {
    openAfterSync = openAfterSync || opened;
    clearTimeout(syncTimer);
    syncTimer = setTimeout(function () {
      var o = openAfterSync; openAfterSync = false;
      refresh().then(function () { if (o && OPEN_ON_ADD && !/\/cart\/?$/.test(location.pathname)) open(); });
    }, 350);
  }
  if (window.fetch && !window.fetch.__sc) {
    var nativeFetch = window.fetch;
    var wrapped = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var h = (init && init.headers) || {};
      var ours = (typeof h.get === 'function' ? h.get('X-Side-Cart') : h['X-Side-Cart']) === '1';
      var p = nativeFetch.apply(this, arguments);
      if (!ours && /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(String(url))) {
        p.then(function (r) { if (r && r.ok) scheduleSync(/\/cart\/add/.test(String(url))); }).catch(function () {});
      }
      return p;
    };
    wrapped.__sc = true;
    window.fetch = wrapped;
  }
  document.addEventListener('fd:cart-synced', function () { scheduleSync(false); });

  /* ---------- timers ---------- */
  function p2(n) { return (n < 10 ? '0' : '') + n; }
  function tick() {
    var now = Date.now();
    var els = root.querySelectorAll('[data-sc-timer]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var end = Date.parse(el.getAttribute('data-end'));
      if (isNaN(end)) continue;
      var d = Math.max(0, end - now);
      if (!d && el.getAttribute('data-hide-end') === 'true') { el.classList.add('is-ended'); continue; }
      var D = Math.floor(d / 864e5), H = Math.floor(d / 36e5) % 24, M = Math.floor(d / 6e4) % 60, S = Math.floor(d / 1e3) % 60;
      var t = el.querySelector('[data-sc-t]');
      if (t) t.textContent = (D ? D + (root.getAttribute('data-t-day') || 'd') + ' ' : '') + p2(H) + ':' + p2(M) + ':' + p2(S);
      var urgent = d > 0 && d < (+el.getAttribute('data-urgent') || 0) * 36e5;
      el.classList.toggle('is-urgent', urgent);
      var tx = el.querySelector('[data-sc-timer-text]');
      if (tx) {
        if (!tx._def) tx._def = tx.textContent;
        tx.textContent = urgent && el.getAttribute('data-urgent-text') ? el.getAttribute('data-urgent-text') : tx._def;
      }
    }
  }
  setInterval(tick, 1000);

  /* ---------- toast ---------- */
  var toastEl;
  function toast(m) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'sc-toast'; document.body.appendChild(toastEl); }
    toastEl.textContent = m;
    toastEl.classList.add('is-show');
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(function () { toastEl.classList.remove('is-show'); }, 2800);
  }

  /* ---------- Theme Editor: секцията се пререндерира при всяка промяна ---------- */
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('[data-sc]');
    if (!r) return;
    root = r;
    tick();
    emit();
  });
  document.addEventListener('shopify:section:select', function (e) { if (e.target.contains(root)) open(); });
  document.addEventListener('shopify:block:select', function (e) { if (root.contains(e.target)) open(); });

  /* Връщане назад (bfcache): количката може да е остаряла */
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });

  window.SideCart = { open: open, close: close, add: add, refresh: refresh, state: state, toast: toast, replaceThemeCart: replaceThemeCart };
  window.addEventListener('load', replaceThemeCart);
  if (window.console) console.info('[SideCart] готов, секция:', SID, '| поемане на бутоните:', root.getAttribute('data-intercept-forms'), '| preview тема:', PREVIEW_ID || 'не (публикувана)');
  tick();
  emit();
})();
